import react from 'react'; // eslint-disable-line
import { graphql, useStaticQuery } from 'gatsby';
import { Article } from '../gatsby/types/article';

export type AllPages = {
  allStrapiNewsArticle: {
    edges: {
      node: Article;
    }[]
  }
}

export const useStrapiNewsArticles = (
): Article[] => {
  const { allStrapiNewsArticle } = useStaticQuery<AllPages>(graphql`
    query {
      allStrapiNewsArticle(filter: {
        articleSettings: {publishStatus: {eq: true}},
        seoSettings: {metaIndex: {eq: "index"}},
      }) {
        edges {
          node {
            id
            articleSettings {
              id
              slug
              title
              publishStatus
              content
              excerpt
              publishDate
            }
          }
        }
      }
    }
  `);

  return allStrapiNewsArticle.edges.map(({ node }) => node);
};

export default useStrapiNewsArticles;
